import React from 'react';
import {
  Container,
  Typography,
  Box,
  Button,
  Link,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const About = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f8f9fe 0%, #ffffff 100%)',
        py: { xs: 4, md: 8 },
        px: { xs: 2, md: 0 },
      }}
    >
      <Container maxWidth="md">
        {/* Back Button */}
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/')}
          sx={{
            mb: 4,
            color: '#546E7A',
            '&:hover': {
              backgroundColor: 'rgba(84, 110, 122, 0.04)'
            }
          }}
        >
          Back to Home
        </Button>

        {/* Main Content */}
        <Box
          sx={{
            background: 'white',
            borderRadius: '16px',
            p: { xs: 3, md: 6 },
            boxShadow: '0 8px 32px -12px rgba(0,0,0,0.1)',
            border: '1px solid rgba(25, 118, 210, 0.1)',
          }}
        >
          <Typography
            variant="h3"
            component="h1"
            sx={{
              mb: 4,
              fontWeight: 800,
              color: '#0A2540',
              fontSize: { xs: '2rem', md: '2.75rem' },
              letterSpacing: '-0.02em'
            }}
          >
            Why I Built Sashy
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: '#546E7A',
              fontSize: '1.1rem',
              lineHeight: 1.8,
              mb: 3
            }}
          >
            I was working a job previously and was unhappy and felt limited. I decided to learn coding and took an AI bootcamp. During the bootcamp I started brainstorming "Where is there valuable information stored in human-written text?", which is where I came up with the idea to analyse online reviews.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: '#546E7A',
              fontSize: '1.1rem',
              lineHeight: 1.8,
              mb: 3
            }}
          >
            Taking learning from my previous job in Sales, I then started thinking "How can I tie changes in online rating back to revenue?". I found this study by Harvard Business School, which analyzed the impact of online ratings on revenue.
          </Typography>

          <Box
            sx={{
              my: 4,
              p: 3,
              borderRadius: '12px',
              backgroundColor: 'rgba(25, 118, 210, 0.04)',
              border: '1px solid rgba(25, 118, 210, 0.1)'
            }}
          >
            <Typography
              variant="body1"
              component="div"
              sx={{
                color: '#1976d2',
                fontSize: '1.1rem',
                lineHeight: 1.8,
                fontStyle: 'italic'
              }}
            >
              <Link
                href="https://www.hbs.edu/ris/Publication%20Files/12-016_a7e4a5a2-03f9-490d-b093-8f951238dba2.pdf"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: 'inherit',
                  textDecoration: 'underline',
                  '&:hover': {
                    color: '#1565C0'
                  }
                }}
              >
                "Reviews, Reputation, and Revenue: The Case of Yelp.com"
              </Link>
              {" found that a one-star increase in Yelp rating leads to a 5-9% increase in revenue for independent restaurants."}
            </Typography>
          </Box>

          <Typography
            variant="body1"
            sx={{
              color: '#546E7A',
              fontSize: '1.1rem',
              lineHeight: 1.8,
              mb: 3
            }}
          >
            From that study, the revenue impact figures from the app were born. You can disagree or argue with the exact percentage, but you can't deny that your online rating will affect your future business, due to the impression it gives to new customers.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: '#546E7A',
              fontSize: '1.1rem',
              lineHeight: 1.8,
              mb: 3
            }}
          >
            Aside from this, the app also just tells you where you're doing well (according to your customers) and where you can improve, which is useful in itself. I hope you enjoy it!
          </Typography>

          <Box
            sx={{
              mt: 6,
              pt: 4,
              borderTop: '1px solid rgba(25, 118, 210, 0.08)',
              textAlign: 'center'
            }}
          >
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate('/signup')}
              sx={{
                py: 2,
                px: 6,
                fontSize: '1.1rem',
                background: 'linear-gradient(135deg, #1976d2 0%, #1565C0 100%)',
                boxShadow: '0 8px 20px -6px rgba(25, 118, 210, 0.5)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #1565C0 0%, #0D47A1 100%)',
                  boxShadow: '0 12px 24px -8px rgba(25, 118, 210, 0.6)',
                  transform: 'translateY(-2px)'
                },
                transition: 'all 0.3s ease'
              }}
            >
              Start Your Journey with Sashy
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default About; 